export default __webpack_public_path__ + "6487758746be2bd3d85d9c88091c0d6a.svg";